import React, { useState } from "react";
import styles from "./change-password.module.css";
import ProfileTitleHr from "../../../../components/profile-title-hr/profile-title-hr";
import { Col, Row } from "antd";
import { Controller, useForm } from "react-hook-form";
import ProfileForm from "../../../../components/profile-form/profile-form";
import ChangePasswordDrawer from "./components/change-password-drawer/change-password-drawer";

const ChangePassword = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { control } = useForm({
    mode: "onChange",
    defaultValues: {
      password: "**********",
    },
  });

  return (
    <div>
      <div className={styles["change-password-box"]}>
        <ProfileTitleHr label="Security" />
        <Row style={{ margin: "20px 0" }}>
          <Col xs={24} sm={24} md={12} lg={12}>
            <Controller
              name="password"
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { error } }) => (
                <ProfileForm.TextInput
                  isEdit={false}
                  inputLabel="Password"
                  required
                  value={field.value}
                  onChange={field.onChange}
                  status={error ? "error" : ""}
                />
              )}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12}>
            <p 
              className={styles["change-password-button"]}
              onClick={() => setIsDrawerOpen(true)}
            >
              Change Password
            </p>
          </Col>
        </Row>
      </div>

      <ChangePasswordDrawer
        isModalOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </div>
  );
};

export default ChangePassword;
